import React, { useEffect, useState } from "react";
import { Card, Row, Col, Table, Typography, Divider } from "antd";
import { getServiceRecordWithDetailsApi } from "../../../../../apiservice/service";
import { numberFormat, convertNumberToWords, formatToCompanyTimezone, numberFormatTax } from "../../../../../lib/functions";
import "./voucher-mobile.css"
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../../../../Auth/authSelectors";

const { Title, Text } = Typography;

const ServiceVoucherBody = ({ service_id, institution, printMode = false, showStamp = false, showSignature = false, showShipping = false, setVoucherNo, setAccName, setCustomerEmail }) => {
  const [data, setData] = useState(null);

  const authInfo = useSelector(selectAuthInfo);
  const isIndia = authInfo?.country?.toLowerCase() === "india";
  const taxLabel = isIndia ? "GST" : "VAT";
  const isGSTDisabled =
    isIndia && authInfo?.gst_enabled == "no";


  useEffect(() => {
    if (!service_id) return;
    getServiceRecordWithDetailsApi({ service_id, from: "voucher" }).then((res) => {
      if (res?.data?.length) {
        const record = res.data[0];
        setData(record);
        // important guard for printMode
        if (!printMode && setVoucherNo) {
          setVoucherNo(record.service_voucher_no);
          setAccName(record.acc_name);
        }

        if (record.email_address) {
          setCustomerEmail?.(record.email_address);
        }
      }
    });
  }, [service_id]);

  if (!data) return null;

  const isIndividual = data.is_cal_type === "individual";
  const items = (data.details || []).map(item => ({
    ...item,
    qty_display:
      item?.item_qty +
      " " +
      item?.unit_symbol +
      (item?.conversion > 1
        ? ", " + item?.retail_qty + " " + item?.base_unit_name
        : ""),
    // done_qty_display :
    //           item?.done_item_qty +
    //           " " +
    //           item?.unit_symbol +
    //           (item?.conversion > 1
    //             ? ", " + item?.done_retail_qty + " " + item?.base_unit_name
    //             : ""),
  }))



  // calculate grand total
  const grandTotal = isIndividual
    ? items.reduce((sum, d) => {
      let qty = d.item_qty || d.pur_o_qty || 0;
      let rate = Number(d.item_rate || 0);
      let total = qty * rate;
      total -= (Number(d.item_discount_per) / 100) * total;
      total += (Number(d.item_tax_per) / 100) * total;
      return sum + total;
    }, 0)
    : data?.total_amount || 0;
  const totalTax = Number(data?.total_tax || 0);
  const cgst = isIndia ? totalTax / 2 : 0;
  const sgst = isIndia ? totalTax / 2 : 0;
  const columns = isIndividual
    ? [
      { title: "NO.", render: (_, __, index) => index + 1, width: 40 },
      {
        title: "Item Name",
        render: (_, record) => (
          <>
            <div>{record.item_name}</div>

            {record.item_description && (
              <div
                style={{
                  fontSize: 11,
                  color: "#666",
                  marginTop: 4,
                  whiteSpace: "pre-wrap",
                }}
              >
                {record.item_description}
              </div>
            )}
          </>
        ),
      },
      {
        title: "Rate",
        dataIndex: "item_rate",
        align: "right",
        render: (v) => Number(v).toFixed(2),
        width: 50
      },
      { title: "Per", dataIndex: "unit_name", align: "right", width: 70 },
      { title: "Quantity", dataIndex: "qty_display", align: "right", width: 80 },
      { title: "Disct%", dataIndex: "item_discount_per", align: "right", render: (v) => Number(v).toFixed(2).replace(/\.00$/, ""), width: 75 },
      ...(!isGSTDisabled
        ? [
          { title: `${taxLabel}% `, dataIndex: "item_tax_per", align: "right", render: (v) => Number(v).toFixed(2).replace(/\.00$/, ""), width: 70 },
        ]
        : []),
      {
        title: "Total",
        align: "right",
        render: (_, d) => {
          let qty = d.item_qty || d.item_qty || 0;
          let rate = Number(d.item_rate || 0);
          let total = qty * rate;
          total -= (Number(d.item_discount_per) / 100) * total;
          total += (Number(d.item_tax_per) / 100) * total;
          return total.toFixed(2);
        },
        width: 90
      },
    ]
    : [
      {
        title: "Item Name",
        render: (_, record) => (
          <>
            <div>{record.item_name}</div>

            {record.item_description && (
              <div
                style={{
                  fontSize: 11,
                  color: "#666",
                  marginTop: 4,
                  whiteSpace: "pre-wrap",
                }}
              >
                {record.item_description}
              </div>
            )}
          </>
        ),
      },
      {
        title: "Rate",
        dataIndex: "item_rate",
        align: "right",
        render: (v) => Number(v).toFixed(2),
        width: 70
      },
      { title: "Per", dataIndex: "per_unit_symbol", align: "right", width: 70 },
      { title: "Quantity", dataIndex: "qty_display", align: "right", width: 110 },
      // { title: "Sold Quantity", dataIndex: "done_qty_display", align: "right" },
      {
        title: "Amount",
        dataIndex: "item_total",
        align: "right",
        render: (v) => Number(v).toFixed(2),
        width: 90
      },
    ];

  return (
    <div data-testid="service-voucher-card" className="voucher-section invoice-v2">
      {/* Header */}

      <Row justify="space-between" align="top" className="invoice-header">

        <Col flex="0 0 320px" className="bill-to" style={{ marginTop: "58px" }}>
          <Text strong>Customer/ Debtor Code: &nbsp;{data.acc_code}</Text>
          <br />
          <Text strong>Name: &nbsp;{data.acc_name}</Text>
          {/* <br />
          <Text >Institution: &nbsp;{data.institution_name}</Text> */}
          <br />
          <Text className="wrap-text">Address: &nbsp; {data.address}</Text>

          <Text>Contact No: &nbsp; +{data.contact_no}</Text>

          {showShipping && data.shipping_address && (
            <>
              <br />
              <br />
              <Text strong>Ship To</Text>
              <br />

              {data.shipping_contact_person && (
                <>
                  <Text>
                    Contact Person : +{data.shipping_contact_person}
                  </Text>
                  <br />
                </>
              )}

              <Text className="wrap-text">
                Address : {data.shipping_address}
              </Text>
              {data.shipping_po_box && (
                <>
                  <Text>
                    Po Box : {data.shipping_po_box}
                  </Text>
                  <br />
                </>
              )}

              {data.shipping_contact_no && (
                <>
                  <Text>
                    Contact No : +{data.shipping_contact_no}
                  </Text>
                  <br />
                </>
              )}
            </>
          )}
        </Col>
        <Col flex="320px" className="invoice-title">
          <Title level={2}>SERVICE</Title>
          <Text strong>Voucher No: {data.service_voucher_no}</Text>
          <br />
          <Text>Service Date: {formatToCompanyTimezone(data.created_date)?.split(" ")[0]}</Text>
          <br />
          <Text>Service By: {data.full_name?.split(" ")[0]}</Text>
          <br />
          <Text className="wrap-text">Address : {institution?.street_address}</Text>
          {institution?.phone_no && <Text>Contact No : &nbsp; +{institution?.phone_no}</Text>}
          <br />
          {institution?.vat_license && <><Text>
            {institution?.country?.trim().toLowerCase() === "united arab emirates"
              ? "TRN No: "
              : "Tax Reg No: "}{" "}
            {institution?.vat_license}
          </Text><br /></>}
          {data.licence_no && <Text>License No : {data.licence_no}</Text>}
        </Col>
      </Row>


      {/* Items Table */}
      <Table
        className="invoice-items"
        dataSource={items}
        columns={columns}
        pagination={false}
        rowKey="pur_o_d_id"
        size="small"
        summary={() => {
          if (isIndividual) {
            return (
              <Table.Summary.Row>
                {/* <Table.Summary.Cell colSpan={5} align="right">
                  <b>Grand Total</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <b>{grandTotal.toFixed(2)}</b>
                </Table.Summary.Cell> */}
              </Table.Summary.Row>
            );
          }
          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={4} align="right">
                  Subtotal
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {Number(data.sub_total || 0).toFixed(2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={4} align="right">
                  Discount
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {Number(data.total_discount || 0).toFixed(2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
              {isIndia ? (
                <>
                  <Table.Summary.Row>
                    <Table.Summary.Cell colSpan={4} align="right">
                      CGST
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      {cgst.toFixed(2)}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>

                  <Table.Summary.Row>
                    <Table.Summary.Cell colSpan={4} align="right">
                      SGST
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      {sgst.toFixed(2)}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                </>
              ) : (
                <Table.Summary.Row>
                  <Table.Summary.Cell colSpan={4} align="right">
                    {taxLabel}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align="right">
                    {totalTax.toFixed(2)}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}


              {/* <Table.Summary.Row>
                <Table.Summary.Cell colSpan={3} align="right">
                  <b>Grand Total</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <b>{Number(grandTotal).toFixed(2)}</b>
                </Table.Summary.Cell>
              </Table.Summary.Row> */}
            </>
          );
        }}
      />

      {/* Footer */}
      <Divider />
      <Row>
        <Col span={16}>
          {/* <Text>Invoice Due : {numberFormat(data.due_total || 0)}</Text>
    <br />
    <Text>
      Current Customer Due : {numberFormat(data.due_amount || 0)}
    </Text> */}
        </Col>

        <Col span={8} style={{ textAlign: "right" }}>
          <div>
            {/* Quantity */}
            <div style={{ display: "flex", textAlign: "left" }}>
              <Text>Quantity Total :</Text>
              <Text>
                ({items.reduce((sum, d) => sum + (Number(d.item_qty) || 0), 0)})
              </Text>
            </div>

            {/* Sub Total */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Sub Total :</Text>
              <Text>{numberFormat(isIndividual ? grandTotal : data.sub_total || 0)}</Text>
            </div>

            {/* {isIndia ? (
              <>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Text>CGST :</Text>
                  <Text>{numberFormat(cgst)}</Text>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Text>SGST :</Text>
                  <Text>{numberFormat(sgst)}</Text>
                </div>
              </>
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Text>{taxLabel} :</Text>
                <Text>{numberFormat(totalTax)}</Text>
              </div>
            )} */}


            {isIndia ? (
              <>
                {data.place_of_supply_type == 'intra' &&
                  <>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Text>CGST :</Text>
                      <Text>{numberFormatTax(data.cgst_amount)}</Text>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Text>SGST :</Text>
                      <Text>{numberFormatTax(data.sgst_amount)}</Text>
                    </div>
                  </>
                }

                {data.place_of_supply_type == 'inter' &&
                  <>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Text>IGST :</Text>
                      <Text>{numberFormatTax(data.igst_amount)}</Text>
                    </div>
                  </>}
              </>
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Text>{taxLabel} :</Text>
                <Text>{numberFormat(totalTax)}</Text>
              </div>
            )}


            {/* Grand Total */}
            <div
              style={{
                borderTop: "1px solid #000",
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 4,
                marginTop: 4,
              }}
            >
              <Text strong>Grand Total ({institution?.currency}): </Text>
              <Text strong>{numberFormat(grandTotal)}</Text>
            </div>

            {/* Paid */}
            <div
              style={{
                borderTop: "1px solid #000",
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 4,
                marginTop: 4,
              }}
            >
              <Text strong>Paid ({institution?.currency}): </Text>
              <Text strong>{numberFormat(data.paid_amount || 0)}</Text>
            </div>

            {/* Due */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 2,
              }}
            >
              <Text strong>Due ({institution?.currency}): </Text>
              <Text strong>{numberFormat(data.due_amount || 0)}</Text>
            </div>
          </div>
        </Col>
      </Row>

      <Divider />
      <Row>
        <Col span={24}>
          <Text>
            In Word of Grand Total :{" "}
            {convertNumberToWords(grandTotal, data?.currency || institution?.currency)}
          </Text>
          <br />
          <Text>Description : {data.narration || "-"}</Text>
        </Col>
      </Row>

      {(showStamp || showSignature) && (
        <div className="invoice-footer-section">
          <div className="footer-right-group">
            {showStamp && institution?.stamp && (
              <div className="stamp-block">
                <img src={institution.stamp} alt="Stamp" />
              </div>
            )}

            {showSignature && institution?.signature && (
              <div className="signature-block">
                <img src={institution.signature} alt="Signature" />
                <div className="sign-line-text">Authorized Signature</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceVoucherBody;
